// @flow
import EventListElementMatch from 'components/event/EventListElementMatch';
import { connect } from 'react-redux';

import { postUserPref } from 'actions/userActions';
import { displayModal } from 'actions/modalActions';
import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/event/EventListElementMatch';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref,
    alertesBilletterie: state.userState.userPref.alertes_billetterie,
    identifie: state.userState.userPref.identifie
  }),
  (dispatch: DispatchType): DispatchProps => ({
    postUserPref: (action: string, value: any, token: string) => dispatch(postUserPref(action, value, token)),
    displayModal: (modalObject: string, content?: Object) => dispatch(displayModal(modalObject, content))
  })
)(EventListElementMatch);
